export const bioSectionLength = 11;
export const questionnaireLength = 51;
